import * as React from 'react';
import {CUSTOM_ERROR} from '../../Config/appConfig';

interface ErrorHandlerWrapperProps {
    addError: (error: any) => void,
    // removeError: () => void,
    clearErrors: () => void
}

class ErrorHandlerWrapper extends React.Component <ErrorHandlerWrapperProps, {}> {
    public componentDidMount() {
        window.addEventListener(CUSTOM_ERROR.ERROR_EVENT_NAME, (error) => this.props.addError(error), true);
        window.addEventListener(CUSTOM_ERROR.CLEAR_ERROR_EVENT_NAME, (error) => this.props.clearErrors(), true);
    }

    public componentWillUnmount() {
        window.removeEventListener(CUSTOM_ERROR.ERROR_EVENT_NAME, (error) => this.props.addError(error), true);
        window.removeEventListener(CUSTOM_ERROR.CLEAR_ERROR_EVENT_NAME, (error) => this.props.clearErrors(), true);
    }

    public render() {
        return this.props.children;
    }
}

export default ErrorHandlerWrapper;



// WEBPACK FOOTER //
// ./src/Components/ErrorHandler/EventHandlerWrapper.tsx